interface WatchlistNewsRegionProps {
  region: string;
  countryFileName: string;
}

class WatchlistNewsRegion {
  private readonly region: string;
  private readonly countryFileName: string;

  public constructor(props: WatchlistNewsRegionProps) {
    this.region = props.region;
    this.countryFileName = props.countryFileName;
  }

  public getRegion(): string {
    return this.region;
  }

  public getCountryFileName(): string {
    return this.countryFileName;
  }
}

class WatchlistNewsRegionResolver {
  private static readonly unitedStatesRegion: WatchlistNewsRegion = new WatchlistNewsRegion({
    region: 'en-US',
    countryFileName: 'United States of America',
  });

  public static resolve(language: string): WatchlistNewsRegion {
    switch (language) {
      case 'tr-TR':
        return new WatchlistNewsRegion({
          region: 'tr-TR',
          countryFileName: 'Turkey',
        });
      case 'ru-RU':
        return new WatchlistNewsRegion({
          region: 'ru-RU',
          countryFileName: 'Russia',
        });
      case 'en-US':
        return WatchlistNewsRegionResolver.unitedStatesRegion;
      case 'uzbek':
        // News country list has no Uzbekistan market, so the previous United States default stays.
        return WatchlistNewsRegionResolver.unitedStatesRegion;
      default:
        return WatchlistNewsRegionResolver.unitedStatesRegion;
    }
  }
}

export default WatchlistNewsRegionResolver;
